import React from "react";

import PropTypes from "prop-types";

import { ODSButton, ODSIcon, ODSText } from "@telekom-ods/react-ui-kit";

import classes from "./Container.module.scss";

const Container = ({ title, description, buttons, children, icon }) => (
	<div className={classes.centered}>
		<div className={classes.contentContainer}>
			{icon && (
				<div className={classes.iconContainer}>
					<ODSIcon
						name={icon.name}
						size={icon.size}
						color={icon.color}
						aria-hidden="true"
					/>{" "}
				</div>
			)}

			<ODSText as="h1" aria-label={title}>
				{title}
			</ODSText>
			<div className={classes.descriptionContainer}>
				<ODSText as="p" className="body">
					{description}
				</ODSText>
			</div>
			{children && (
				<div className={classes.childrenContainer}>
					{children}
				</div>
			)}
			{buttons && buttons.length > 0 && (
				<div className={classes.buttonContainer}>
					{buttons.map((button, index) => (
						<ODSButton
							key={index}
							buttonType="standard"
							label={
								button.label ||
								"Button"
							}
							size={
								button.size ||
								"large"
							}
							variant={
								button.variant ||
								"primary"
							}
							onClick={
								button?.onClick
							}
							className={
								classes.button ||
								"Button"
							}
							aria-label={
								button.ariaLabel ||
								"Button"
							}
							tabIndex={
								button.tabIndex ||
								0
							}
							disabled={
								button?.disabled
							}
						/>
					))}
				</div>
			)}
		</div>
	</div>
);

Container.propTypes = {
	title: PropTypes.string,
	description: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
	buttons: PropTypes.arrayOf(
		PropTypes.shape({
			label: PropTypes.string,
			size: PropTypes.string,
			variant: PropTypes.string,
			onClick: PropTypes.func,
			ariaLabel: PropTypes.string,
			tabIndex: PropTypes.number,
			disabled: PropTypes.bool
		})
	),
	children: PropTypes.node,
	icon: PropTypes.object
};

export default Container;
